// Progress page route for an inspection-docs zip export.
import React from "react";

const ProjectQaAssemblyExportsShow = React.lazy(() => import("./show"));

export default [
  { path: "/project/:project_id/qa/assembly_exports/:id", component: ProjectQaAssemblyExportsShow, name: "ProjectQaAssemblyExport" },
];
